<template>
  <div class="index">
    <el-row class='title'>欢迎来到星罗好货提报平台</el-row>
  </div>
</template>

<style scoped>
  .title{
    line-height:100px;
    text-align: center;
  }
</style>

<script>
export default {
  name: 'index',
  components: {
  }
}
</script>
